import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { DosageRepeatVM } from "@/service/view-models/dosage-choices/dosage-repeat-vm";
import { staticImplements } from "@/utilities/static-implements";
import { Duration } from "@/utilities/types/duration";
import { XmlDocumentWrapper } from "@/utilities/xml-helpers/xml-document-wrapper";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { BaseDosageChoice } from ".";
import { FormulationAndRoute } from "../parts/formulation-and-route";

@staticImplements<ResponseModelInterfaceStatic>()
export class DosageRepeat extends BaseDosageChoice
{
    public constructor(
        public iterations: number,
        public dosage: BaseDosageChoice,
    )
    {
        super();
    }

    /**
     * @inheritdoc
     */
    public makeViewModel(): DosageRepeatVM
    {
        return new DosageRepeatVM().fillFromModel(this);
    }

    /**
     * @inheritdoc
     */
    public getClosestNextDoseDate(knownDose: Date, current: Date): Date
    {
        return this.dosage.getClosestNextDoseDate(knownDose, current);
    }

    /**
     * @inheritdoc
     */
    public getClosestPreviousDoseDate(knownDose: Date, current: Date): Date
    {
        return this.dosage.getClosestPreviousDoseDate(knownDose, current);
    }

    /**
     * @inheritdoc
     */
    public getDoseValueForDisplay(): number
    {
        return this.dosage.getDoseValueForDisplay();
    }

    /**
     * @inheritdoc
     */
    public getDoseUnitForDisplay(): string
    {
        return this.dosage.getDoseUnitForDisplay();
    }

    /**
     * @inheritdoc
     */
    public getInfusionTimeForDisplay(): Duration|null
    {
        return this.dosage.getInfusionTimeForDisplay();
    }

    /**
     * @inheritdoc
     */
    public getIntervalForDisplay(): Duration
    {
        return this.dosage.getIntervalForDisplay();
    }

    /**
     * @inheritdoc
     */
    public getRouteForDisplay(): FormulationAndRoute
    {
        return this.dosage.getRouteForDisplay();
    }

    /**
     * @inheritdoc
     */
    public static makeFromXml(elem: XmlElementWrapper): DosageRepeat
    {
        return new this(
            elem.firstChildByTag("iterations").valueAsNumber(),
            BaseDosageChoice.makeFromXmlGeneric(elem.firstChildWithTagIn(BaseDosageChoice.allowedTagNames))
        );
    }

    /**
     * @inheritdoc
     */
    public getXml(doc: XmlDocumentWrapper): XmlElementWrapper
    {
        const element = doc.createElement("dosageRepeat");

        element.appendNewElement("iterations", this.iterations.toFixed(0));
        element.append(this.dosage.getXml(doc));

        return element;
    }
}
